export default __webpack_public_path__ + "static/media/image-main-1-m.9ad3def0.webp";